import $ from 'jquery'
import 'floatthead'

const floatThead = {}
//let table = undefined

floatThead.install = (Vue) => {
    Vue.prototype.$floatThead = {
        ini(tabla, options = undefined){                
            let t = $(tabla)

            if(options){
                //console.log("aplico options")
                t.floatThead(options)
            }
            else{
                //console.log("aplico default")
                t.floatThead({
                    position: 'fixed',
                    scrollContainer: true
                })
            }
            t.floatThead('reflow');  

            return t;
        },
        reflow(tabla){
            let t = $(tabla)
            t.floatThead('reflow')

            return t;
        },
        el(tabla){
            return $(tabla)
        }

    }
}

export default floatThead